/* Enhancement only. Shrine owns gallery, variant resolution, prices, POST/cart, errors and sticky ATC. */
(() => {
  if (window.pnProductEnhancement) return;
  window.pnProductEnhancement = true;
  const selector = '.pn-product, .pn-product-story';
  // Read the native selected input; Shrine continues to resolve IDs, prices and media.
  document.addEventListener('change', event => {
    const group = event.target.closest?.('.pn-product[data-pn-parity] variant-selects .product-form__input');
    const label = group?.querySelector('[data-pnp-selected-option]');
    if (!label) return;
    const selected = group.querySelector('input[type="radio"]:checked, select');
    if (selected) label.textContent = selected.value === 'Verde' ? 'Green' : selected.value;
  });
  function init(root = document) {
    const scopes = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) scopes.unshift(root);
    scopes.forEach(scope => {
      // Archived Impact aria-expanded was frozen false; native details owns the disclosure state.
      scope.querySelectorAll('details.product-info__accordion').forEach(details => {
        details.removeAttribute('aria-expanded');
        details.removeAttribute('is');
      });
      scope.querySelectorAll('.an-source img, .an-source video').forEach(media => {
        if (media.dataset.pnBound) return;
        media.dataset.pnBound = 'true';
        if (media.tagName === 'IMG') media.decoding = 'async';
        const load = () => {
          let changed = false;
          [media, ...media.querySelectorAll('source')].forEach(node => {
            for (const attr of ['src', 'srcset']) {
              if (!node.getAttribute(attr) && node.dataset[attr]) {
                node.setAttribute(attr, node.dataset[attr]); changed = true;
              }
            }
          });
          // Global an-interactions may already have loaded it. Never reset an active video.
          if (media.tagName === 'VIDEO' && changed) media.load();
        };
        const clearError = () => {
          media.nextElementSibling?.matches('.pn-media-error') && media.nextElementSibling.remove();
        };
        media.addEventListener('load', clearError);
        media.addEventListener('loadeddata', clearError);
        media.addEventListener('error', () => {
          if (media.nextElementSibling?.matches('.pn-media-error')) return;
          const box = document.createElement('div'); box.className = 'pn-media-error';
          box.setAttribute('role', 'status');
          const text = document.createElement('span'); text.textContent = 'Media could not be loaded. ';
          const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Retry';
          retry.addEventListener('click', () => {
            clearError();
            if (media.tagName === 'VIDEO') { load(); media.load(); }
            else { const src = media.getAttribute('src') || media.dataset.src; if (src) media.src = src; }
          });
          box.append(text, retry); media.after(box);
        });
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            if (entries.some(e => e.isIntersecting)) { load(); observer.disconnect(); }
          }, {rootMargin:'300px'});
          observer.observe(media);
        } else load();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
